import React from "react";

const SharePost = ({ onShare, image }) => {
  return (
    <>
      <h2>SHARE THIS POST!</h2>
      <img src={image} alt="Car" />
      <p>
        A link to this listing and image will be shared on your mobile device.
      </p>
      <button onClick={onShare} className="primary">
        Share Now
      </button>
    </>
  );
};

export default SharePost;
